import { useEffect, useState } from 'react';

import { Select } from 'twyne-new.ui';

import { getChange, getValue } from './utils';

export default function SelectCreatable({ isMulti, options: defaultOptions, onChange, name, value }) {
  const [options, setOptions] = useState([])

  useEffect(() => {
    setOptions(state => state.length ? state : [...defaultOptions])
  }, [defaultOptions])

  return <Select
    creatable
    id={name}
    options={options}
    multi={isMulti}
    value={getValue(value, isMulti)}
    onChange={getChange(onChange, isMulti)}
    closeOnSelect={!isMulti}
    promptTextCreator={str => `Search for ${name} "${str}"`}
  />
}
